import { motion } from 'framer-motion';
export interface BodyBlockProps {
  body?: string;
}

export function BodyBlock({ body }: BodyBlockProps) {
  const bodyReveal = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { ease: [0, 1, 1, 1], duration: 0.8 },
    },
  };

  if (!body) return null;

  return (
    <motion.div
      variants={bodyReveal}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.1 }}
      className={`type-body-press flex flex-col gap-3 font-WorkSans md:gap-5`}
      dangerouslySetInnerHTML={{ __html: body }}
    />
  );
}
